module.exports = __webpack_public_path__ + "img/img16.f7c9be9f.svg";